import { render } from "./PlayerStatus.vue?vue&type=template&id=13238b31&ts=true"
import script from "./PlayerStatus.vue?vue&type=script&lang=ts"
export * from "./PlayerStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__